import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import '../../index.css';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
  return (
    <footer className="footer bg-white py-12 relative text-zinc-700 text-base md:text-lg leading-relaxed tracking-wide border-t border-gray-100">
      <motion.div className="container mx-auto px-4">
        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <motion.div className="text-zinc-700">
            <h3 className="text-2xl font-bold mb-2 text-blue-800">Dr. Gangesh Gunjan</h3>
            <p className="text-sm font-semibold text-gray-800 mb-1">
              MBBS (Hons.) (Gold Medalist), MS (Gen Surgery), M.Ch (Neurosurgery)
            </p>
            <p className="text-xs text-gray-600 mb-2">
              Associate Director & Head, Dept. of Neurosurgery
            </p>
            <div className="text-xs bg-blue-50 border border-blue-200 p-2 rounded mb-4">
              <span className="font-semibold text-blue-900 block">Registration Status:</span>
              <span className="text-gray-700 block">Registered Medical Practitioner (RMP)</span>
              <span className="text-amber-800 font-medium block">SMR / NMR: [Pending Confirmation]</span>
            </div>
            <motion.div className="flex space-x-4">
              <a href="/#" aria-label="Facebook Profile" className="text-zinc-600 hover:text-blue-600 transition-colors duration-300">
                <FaFacebookF size={18} />
              </a>
              <a href="/#" aria-label="Twitter Profile" className="text-zinc-600 hover:text-blue-600 transition-colors duration-300">
                <FaTwitter size={18} />
              </a>
              <a href="/#" aria-label="LinkedIn Profile" className="text-zinc-600 hover:text-blue-600 transition-colors duration-300">
                <FaLinkedinIn size={18} />
              </a>
            </motion.div>
          </motion.div>
          <motion.div>
            <h3 className="text-xl font-bold mb-4 text-blue-800">Clinical Consultation</h3>
            <p className="flex items-start mb-3 text-sm text-gray-700">
              <FaMapMarkerAlt className="mr-3 mt-1 text-blue-600 flex-shrink-0" />
              <span>Room no. 1011, Sarvodaya Hospital, Sector 16C, Gaur City 2, Greater Noida West, Uttar Pradesh 201009</span>
            </p>
            <p className="flex items-center mb-3 text-sm text-gray-700">
              <FaPhoneAlt className="mr-3 text-blue-600 flex-shrink-0" />
              <a href="tel:+917727834367" className="hover:text-blue-600">+91-7727834367</a>
            </p>
            <p className="flex items-center mb-3 text-sm text-gray-700">
              <FaEnvelope className="mr-3 text-blue-600 flex-shrink-0" />
              <span>gangeshgunjan97@gmail.com</span>
            </p>
          </motion.div>
          <motion.div className="text-gray-700">
            <h3 className="text-xl font-bold mb-4 text-blue-800">OPD Consultation Hours</h3>
            <p className='text-sm font-semibold text-gray-800 mb-1'>Sarvodaya Hospital, Greater Noida West</p>
            <p className='text-sm text-gray-600 mb-2'>Room no. 1011, OPD Block</p>
            <p className='text-sm text-gray-700 font-medium'>Monday – Saturday: 9:00 AM – 5:00 PM</p>
            <p className='text-xs text-gray-500 mt-2'>Prior appointment recommended for clinical evaluation.</p>
          </motion.div>
          <motion.div>
            <h3 className="text-xl font-bold mb-4 text-blue-800">Consultation Access</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/top-neurosurgeon-in-bishanpura" className="text-zinc-700 hover:text-blue-600 transition-colors duration-300">Bishanpura Region</Link>
              </li>
              <li>
                <Link to="/expert-neurosurgeon-prithvi-vihar" className="text-zinc-700 hover:text-blue-600 transition-colors duration-300">Prithvi Vihar Region</Link>
              </li>
              <li>
                <Link to="/best-brain-and-spine-surgeon-hapur" className="text-zinc-700 hover:text-blue-600 transition-colors duration-300">Hapur Region</Link>
              </li>
              <li>
                <Link to="/leading-neurosurgeon-bulandshahr" className="text-zinc-700 hover:text-blue-600 transition-colors duration-300">Bulandshahr Region</Link>
              </li>
              <li>
                <Link to="/best-neurosurgeon-in-greater-noida" className="text-zinc-700 hover:text-blue-600 transition-colors duration-300">Greater Noida West</Link>
              </li>
            </ul>
          </motion.div>
        </motion.div>

        {/* Medical Disclaimer per NMC regulations */}
        <div className="mt-8 pt-6 border-t border-gray-200 text-xs text-gray-500 leading-relaxed text-center max-w-4xl mx-auto">
          <p className="font-semibold text-gray-600 mb-1">Medical Education & Practice Disclaimer</p>
          <p>
            The information published on this website is for public health education and general clinical awareness only. It does not replace independent professional medical diagnosis, clinical judgment, or treatment. Patients should consult Dr. Gangesh Gunjan or a qualified medical practitioner for personalized assessment.
          </p>
        </div>

        <motion.div className="mt-6 pt-4 border-t border-gray-100 text-center text-xs text-gray-400">
          <p className="mb-2">&copy; {new Date().getFullYear()} Dr. Gangesh Gunjan. All rights reserved.</p>
          <p>
            Website by <a href="https://rnahealthtech.com" className="text-zinc-600 hover:underline">RNA HealthTech</a>
          </p>
        </motion.div>
      </motion.div>
    </footer>
  );
};

export default Footer;
